import React from "react";
import { Layer, ResponsiveContext } from "grommet";
import Section from "./Section";
import { faXmarkLarge as IconClose } from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";
import { snakeCase } from "../utils/string";

const Drawer = ({
    title, onClose, children, hideBorder=false, hideDeepLink=true, loggingComponentName, ...rest
}) => (
    <Layer
        position="right"
        full="vertical"
        modal
        onEsc={onClose}
    >
        <ResponsiveContext.Consumer>
            {(size) => (
                <Section
                    {...(title ? {title} : {})}
                    border={false}
                    round={false}
                    margin="none"
                    fill="vertical"
                    width={size === "small" ? { min: 'medium'} : { max: 'medium', min: 'medium'}}
                    pad="none"
                    headerProps={{
                        pad: 'xsmall',
                    }}
                    control={
                        <Button
                            event={{section: `${loggingComponentName || snakeCase(title)}_drawer`, element: 'close'}}
                            onClick={onClose}
                            hoverIndicator
                            label={<FontAwesomeIcon SelectedIcon={IconClose} size="xsmall" />}
                        />
                    }
                    contentProps={{
                        flex: true,
                        overflow: 'auto'
                    }}
                    background="background"
                    hideDeepLink={hideDeepLink}
                    hideBorder={hideBorder}
                    {...rest}
                >
                    {children}
                </Section>
            )}
        </ResponsiveContext.Consumer>
    </Layer>
);

export default Drawer;
